<template>
  <v-card outlined>
    <v-card-title class="d-flex justify-space-between">
      <div class="d-flex justify-space-between">
        <h5>Händelser</h5>
      </div>
    </v-card-title>
    <v-card-text>
      <v-timeline
        dense
        align-top
      >
        <v-timeline-item
          v-for="(log,idx) in logs"
          :key="idx"
          :class="log.type"
          small
        >
          <v-row>
            <v-col
              class="pl-0 pt-0"
              cols="5"
            >
              {{ log.createdAt | datetime }}
            </v-col>
            <v-col class="pl-0 pt-0">
              {{ getWho(log.creator) }}
              <div class="caption">
                {{ get(log, 'state.explanation', '') }}
              </div>
            </v-col>
          </v-row>
        </v-timeline-item>

      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import API from '@/services/api.js'
import get from 'lodash/get'

export default {
  data: () => ({
    logs: [],
    runSem: false
  }),

  watch: {
    'selectedApplication.id': {
      handler (newValue, oldValue) {
        this.initStateLogs()
      }
    },
    'selectedApplication.approvedBy': {
      handler (newValue, oldValue) {
        this.initStateLogs()
      },
      deep: true
    },
    'selectedApplication.orderedBy': {
      handler (newValue, oldValue) {
        this.initStateLogs()
      },
      deep: true
    }
  },

  created() {
    this.initStateLogs()
  },

  computed: {
    ...mapGetters('application', ['selectedApplication', 'isCompanyApplication']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole'])
  },

  methods: {
    initStateLogs() {
      //- To keep it from running multiple times at once
      if (this.runSem) return
      this.runSem = true

      //- Grab some data
      API.getApplicationStateLogs(get(this, 'selectedApplication.id', 0))
        .then(res => {
          this.logs = res.data ?
            res.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0)) :
            []
          this.runSem = false
        })
        .catch(e => {
          console.log(e)
          this.logs = []
          this.runSem = false
        })
    },

    get,

    getWho(item) {
      return item ? `${item.firstName} ${item.lastName}` : ''
    }
  }
}
</script>

<style lang="scss">
.v-timeline-item.application {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: var(--v-primary-darken4) !important;
        background-color: var(--v-primary-darken4) !important;
      }
    }
  }
}
.v-timeline-item.order {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(0, 105, 15, 0.5) !important;
        background-color: rgba(0, 105, 15, 0.5) !important;
      }
    }
  }
}
.v-timeline-item.grundutbildning {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(136, 226, 0, 0.5) !important;
        background-color: rgba(136, 226, 0, 0.5) !important;
      }
    }
  }
}
.v-timeline-item.kvalificeringstid {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(255, 151, 0, 0.5) !important;
        background-color: rgba(255, 151, 0, 0.5) !important;
      }
    }
  }
}
.v-timeline-item.ebok {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: rgba(226, 0, 190, 0.5) !important;
        background-color: rgba(226, 0, 190, 0.5) !important;
      }
    }
  }
}
</style>